import { Component, OnInit, Inject, HostListener, PLATFORM_ID, OnDestroy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../Services/authentication/authentication.service';
import { WINDOW } from '../../Services/window/window.service';
import { HeaderService } from '../../Services/header/header.service';
import { LangService } from '../../Services/lang/lang.service';
import { AnalyticsService } from '../../Services/analytics/analytics.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  // providers: [AuthenticationService]
})
export class HeaderComponent implements OnInit, OnDestroy {

  logoutAlert: string;
  logoutError = false;
  public isSolid = false;
  headerChangeableBG = true;
  showNav = true;
  noHeader = false;
  public isTripHeader = false;
  public userLogged;
  public _userAvatarObj;
  public _userCount;
  public _userFirstName;
  public returnUrl;
  public headerTitle;
  public secondaryHeaderTitle;
  public headerClass;
  public o2Url;
  private headerBGSubscriber;
  private headerScrollSubscriber;
  private headerNavSubscriber;
  private noHeaderSubscriber;
  private tripHeaderSubscriber;
  private headerTitleSubscriber;
  private secondaryHeaderTitleSubscriber;
  private routeSubscriber;
  private authSubscriber;
  private headerClassSubscriber;

  constructor(
    private Auth: AuthenticationService,
    private route: Router,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window,
    public header: HeaderService,
    @Inject(PLATFORM_ID) private platform: Object,
    private routed: ActivatedRoute,
    private langService: LangService,
    private analytics: AnalyticsService
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const num = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    if (this.headerChangeableBG) {
      if (num > 100) {
        this.header.isSolidBg(true);
      } else if (this.isSolid && num < 10) {
        this.header.isSolidBg(false);
      }
    }
  }

  ngOnInit() {
    this.headerBGSubscriber = this.header.bg.subscribe(res => {
      this.isSolid = res;
    });
    this.headerScrollSubscriber = this.header.headerScroll.subscribe(res => {
      this.headerChangeableBG = res;
    });
    this.headerNavSubscriber = this.header.nav.subscribe(res => {
      this.showNav = res;
    });
    this.noHeaderSubscriber = this.header.noheader.subscribe(res => {
      this.noHeader = res;
    });
    this.tripHeaderSubscriber = this.header.istripheader.subscribe(res => {
      this.isTripHeader = res;
    });
    this.headerTitleSubscriber = this.header.HeaderTitle.subscribe(res => {
      this.headerTitle = res;
    });
    this.secondaryHeaderTitleSubscriber = this.header.SecondaryHeaderTitle.subscribe(res => {
      this.secondaryHeaderTitle = res;
    });
    this.headerClassSubscriber = this.header.headerClass.subscribe(res => {
      this.headerClass = res;
    });
    if (isPlatformBrowser(this.platform)) {
      this.routeSubscriber = this.route.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.returnUrl = event.url;
          this.o2Url = event.url.indexOf('partners/o2priority') > -1;
        }
      });
    }
  }

  getCurrentLang() {
    return this.langService.getCurrentLang();
  }

  isLoggedIn() {
    return this.Auth.isLoggedIn();
  }

  logout() {
    this.authSubscriber = this.Auth.logout().subscribe(
      res => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        // this.route.navigate(['/']);
      },
      err => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        this.logoutError = true;
        this.logoutAlert = JSON.parse(err._body).error;
        return err;
      }
    );
  }

  getUserFirstName() {
    this._userFirstName = this.Auth.getUserFirstName();
    return this._userFirstName;
  }

  getUserAvatarImage() {
    this._userAvatarObj = this.Auth.getUserAvatar();
    return this._userAvatarObj.image_url;
  }

  getUserLuckyCount() {
    this._userCount = this.Auth.getUserSearchCount();
    return this._userCount;
  }

  userIconClicked() {
    this.analytics.logEvent('intro_user_icon');
  }

  ngOnDestroy() {
    if (this.headerBGSubscriber) {
      this.headerBGSubscriber.unsubscribe();
    }
    if (this.headerScrollSubscriber) {
      this.headerScrollSubscriber.unsubscribe();
    }
    if (this.headerNavSubscriber) {
      this.headerNavSubscriber.unsubscribe();
    }
    if (this.noHeaderSubscriber) {
      this.noHeaderSubscriber.unsubscribe();
    }
    if (this.tripHeaderSubscriber) {
      this.tripHeaderSubscriber.unsubscribe();
    }
    if (this.headerTitleSubscriber) {
      this.headerTitleSubscriber.unsubscribe();
    }
    if (this.secondaryHeaderTitleSubscriber) {
      this.secondaryHeaderTitleSubscriber.unsubscribe();
    }
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.authSubscriber) {
      this.authSubscriber.unsubscribe();
    }
    if (this.headerClassSubscriber) {
      this.headerClassSubscriber.unsubscribe();
    }
  }

  actionTriggered(action) {
    if (action === 'logo') {
      this.analytics.logEvent('header_logo');
    }
    if (action === 'picks') {
      this.analytics.logEvent('header_our_picks');
    }
    if (action === 'reviews') {
      this.analytics.logEvent('header_reviews');
    }
    if (action === 'giftcard') {
      this.analytics.logEvent('header_gift_cards');
    }
    if (action === 'partners') {
      this.analytics.logEvent('header_partnerships');
    }
    if (action === 'contact') {
      this.analytics.logEvent('header_contact');
    }
    if (action === 'user_trips') {
      this.analytics.logEvent('header_user_trips');
    }
  }

  // updatePageStatus(data) {
  //   this.userLogged = data;
  //   if (this.userLogged) {
  //     this._userAvatarObj = this.Auth.getUserAvatar();
  //     this._userCount = this.Auth.getUserSearchCount();
  //     this._userFirstName = this.Auth.getUserFirstName();
  //   } else if(this.isLoggedIn()) {
  //     this._userAvatarObj = this.Auth.getUserAvatar();
  //     this._userCount = this.Auth.getUserSearchCount();
  //     this._userFirstName = this.Auth.getUserFirstName();
  //   }
  // }
}
